import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState } from 'react';
import Loader from '../Layout/Loader';
import { OpenBase64Pdf, setFocus, setTitle, ReverseFormatDate, GetDate } from "../Common/Common";
import { Cookies } from 'react-cookie';
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { getCommonData } from '../Common/CommanServices';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { useNavigate } from "react-router-dom";

const StockReconciliation = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode');
    const SalesPersonName = cookies.get('warehouseName');
    const SalesPersonCode = cookies.get('warehouseCode');
    const [isLoading, setIsLoading] = useState(false);
    const [SalesPersonPre, setSalesPersonPre] = useState('')
    const [tableLoading, setTableLoading] = useState(false);
    const [salesPersonData, setSalesPersonData] = useState([])
    const [ItemNoData, setItemNoData] = useState([]);

    const [MenuText, setMenuText] = useState("Stock Reconciliation");


    const [filterData, setFilterData] = useState({
        SearchFieldValue: "",
        SearchText: "",
        StartValue: "1",
        PageIndex: "1",
    })

    const [formData, setformData] = useState({
        SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
        Remarks:"",
        ItemDetails: [
        ]
    });
    const getSalesPerson = () => {
        setSalesPersonData([]);
        let temp = {
            Type: "GetWarehouse",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let salesPersonData = res.autoCompleteData || [];
                setSalesPersonData(salesPersonData);
            } else {
                console.error("Error fetching salesperson data:", res.message);
                setSalesPersonData([]);
            }
        });
    };
    let SalesPersonArr = []
    for (let i = 0; i < salesPersonData.length; i++) {
        let mydata = salesPersonData[i]?.values
        SalesPersonArr.push(mydata)
    };

    const handleClear = () => {

        setformData({
            ...formData,
            SalesPerson: "",
            Remarks:"",
            Item: "",
            ItemDetails: []
        });
        setFocus('txtSalesPerson');
    }
    useEffect(() => {
        setTitle('StockReconciliation', setOpen);
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, []);

    useEffect(() => {
        setFocus('txtSalesPerson');
    }, [filterData.PageIndex]);

    const handleSubmit = async () => {
        setIsLoading(true)
       
        const loginCodeString = String(LoginUserCode);
        let data = {
            ...formData,
            ItemDetails: formData.ItemDetails = formData.ItemDetails.map((item) => {
                item.Item = item?.ItemNo?.toString()
                if (item.EmptyItem === 'YES') {
                    item.EmptyItem = true;
                    item.Variance = item?.Variance?.toString()
                } else {
                    item.Variance = item?.Variance?.toString()
                    item.EmptyItem = false;
                }
                return item;
            }),
            
            Token, LoginUserCode: loginCodeString
        }
        post(`${API_SERVER}/api/Operation/SaveStockReconciliation`, { ...data }, (res) => {

            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus);
                handleClear()
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);
            }
            if (res.focus !== "") {
                setFocus(res.focus)
            }
            setIsLoading(false);
        })
    }
    const handlePrintData = (ID,) => {
        const loginCodeString = String(LoginUserCode);

        const data = {
            ...filterData,
            Source: "",
            SalesPerson: formData.SalesPerson,
            WareHouse: formData.WareHouse,
            Token,
            LoginUserCode: loginCodeString
        };
        post(`${API_SERVER}/api/Print/StockReturnPrint`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                OpenBase64Pdf(res.documentPdfBase64, 'StockReturnPrint_' + ID, '_blank');
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            if (res.status === 'ERROR' || res.message !== '') {
                AlertBox(res.status, res.message, res.focus);
            }
            if (res.focus !== "") {
                setFocus(res.focus);
            }
        })
    }
    const GetsalesPersonWiseInhandData = (SalesPerson) => {
        setformData(prevFormData => ({
            ...prevFormData,
            SalesPerson: SalesPerson,
            ItemDetails: []
        }));
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString,
            SalesPerson: SalesPerson,
            ...filterData
        };
        setTableLoading(true);
        post(`${API_SERVER}/api/Operation/ShowExStockReconciliation`, { ...data, SalesPerson: SalesPerson }, (res) => {
            if (res.Status === 'SUCCESS') {
                let itemDetails = [];
                res.Data.forEach((item, index) => {
                    let Item = {};
                    Item.ItemNo = item.ItemNo;
                    Item.EmptyItem = item.EmptyItem;
                    Item.InHandQuantity = item.InHandQuantity !== null ? item.InHandQuantity : '';
                    Item.Quantity = item.Quantity != null && item.Quantity !== '' ? item.Quantity : '';
                    Item.Variance = item.Variance != null && item.Variance !== '' ? item.Variance : '';
                    Item.Remarks = item.Remarks != null && item.Remarks !== '' ? item.Remarks : '';
                    itemDetails.push(Item);
                });

                setformData({
                    ...formData,

                    ItemDetails: itemDetails
                });
                setformData(prevFormData => ({
                    ...prevFormData,
                    SalesPerson: SalesPerson ? SalesPerson : "",
                    ItemDetails: itemDetails
                }));
            } else if (res.Message === "EXPIRED") {
                navigate('/Login');
            }
            if (res.Status === "ERROR") {
                AlertBox(res.Status, res.Message, res.Focus);
            }
        });
    };

    const getItemNo = () => {
        setItemNoData([])
        let temp = {
            Type: "GetItemNo",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let itemData = res.autoCompleteData || [];
                setItemNoData(itemData);
            } else {
                setItemNoData([]);
            }
        });
    }
    let ItemNoArr = []
    for (let i = 0; i < ItemNoData.length; i++) {
        let mydata = ItemNoData[i]?.values
        ItemNoArr.push(mydata)
    };

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                disabled={SalesPersonCode ? true : false}
                                                label='Sales Person / Warehouse'
                                                placeholder="Sales person"
                                                maxLength='50'
                                                options={SalesPersonArr}
                                                id='txtSalesPerson'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={(e) => {
                                                    getSalesPerson()
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus("txtWareHouse")
                                                    };

                                                }}
                                                inputValue={formData.SalesPerson ? formData.SalesPerson : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    setformData({ ...formData, SalesPerson: newInputValue })
                                                    setSalesPersonPre(newInputValue)
                                                    GetsalesPersonWiseInhandData(newInputValue)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Stock Reconcilation Date </label>
                                            <DatePicker selected={ReverseFormatDate(GetDate(0))}
                                                disabled='disabled'
                                                id='txtStockReturnDate'
                                                className="form-control"
                                                placeholderText='Select Stock Reconcilation Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'

                                                maxDate={new Date()}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('btnSearch');
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Remarks</label>
                                            <input
                                                id='txtRemarks'
                                                type="text"
                                                maxLength="100"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtRemarks');
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Remarks'
                                                value={formData.Remarks}
                                                onChange={(e) => {
                                                    setformData({ ...formData, Remarks: e.target.value })
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-12 mt-4">
                                        <div className="lms-new-button text-center">
                                            <button className="button save-btn" id='btnSearch' onClick={() => {
                                                const selectedSalesPerson = formData.SalesPerson ? formData.SalesPerson : null;
                                                GetsalesPersonWiseInhandData(selectedSalesPerson);
                                            }}>
                                                <i className="bi bi-search" /> Search
                                            </button>

                                            <button className="button save-btn" id='btnSave' onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <>  {
                formData ? (
                    <div className="col-lg-12 col-md-12 col-sm-12 mt-5">

                        <div className="recoard-bata service-content-area" style={{ padding: '0rem 0rem 0rem 0rem' }}>
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr className='light-bg'>
                                            <th>Item</th>
                                            <th>EmptyItem</th>
                                            <th>InHandQuantity</th>
                                            <th>Quantity</th>
                                            <th>Variance</th>
                                            <th>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {formData.ItemDetails?.map((item, bodyIndex) => (
                                            <tr className="TableTrhover" key={`row${bodyIndex}`}>
                                                <td>{item.ItemNo}</td>
                                                <td>{item.EmptyItem}</td>
                                                <td>{item.InHandQuantity}</td>
                                                <td>
                                                    <input
                                                        className="form-control"
                                                        type='text'
                                                        id={`txtQuantity${bodyIndex}`}
                                                        style={{ minWidth: '20px' }}
                                                        maxLength="10"
                                                        value={item.Quantity}
                                                        onChange={(e) => {
                                                            const inputValue = e.target.value;
                                                            if (/^\d*$/.test(inputValue)) {
                                                               
                                                                setformData(prevSaveData => {
                                                                    const updatedItemDetails = prevSaveData.ItemDetails.map((item, i) => {
                                                                        if (i === bodyIndex) {
                                                                            const updatedItem = { ...item, Quantity: inputValue };
                                                                            const expectedQuantity = item.InHandQuantity || 0;
                                                                            updatedItem.Variance = inputValue-expectedQuantity ;
                                                                            if (inputValue === '' || inputValue === '0') {
                                                                                updatedItem.Variance = '';
                                                                            }


                                                                            return updatedItem;
                                                                        }
                                                                        return item;
                                                                    });

                                                                    return {
                                                                        ...prevSaveData,
                                                                        ItemDetails: updatedItemDetails
                                                                    };
                                                                });
                                                            }
                                                        }}
                                                    />
                                                </td>
                                                <td> <input
                                                    className="form-control"
                                                    type='text'
                                                    id={`txtVariance${bodyIndex}`}
                                                    style={{ minWidth: '20px', cursor: 'not-allowed' }}
                                                    maxLength="10"
                                                    disabled={item.Quantity || item.Quantity === ''}
                                                    value={item.Variance}
                                                    onChange={(e) => {
                                                        const inputValue = e.target.value;
                                                        if (/^\d*$/.test(inputValue)) {
                                                            setformData(prevSaveData => ({
                                                                ...prevSaveData,
                                                                ItemDetails: prevSaveData.ItemDetails.map((item, i) => {
                                                                    if (i === bodyIndex) {
                                                                        return { ...item, Variance: inputValue };
                                                                    }
                                                                    return item;
                                                                })
                                                            }));
                                                        }

                                                    }}
                                                /></td>
                                                <td> <input
                                                    className="form-control"
                                                    type='text'
                                                    id={`txtRemarks${bodyIndex}`}
                                                    style={{ minWidth: '30px' }}
                                                    maxLength="100"
                                                    value={item.Remarks}
                                                    onChange={(e) => {
                                                        const inputValue = e.target.value;
                                                        if (/^\d*$/.test(inputValue)) {
                                                            setformData(prevSaveData => ({
                                                                ...prevSaveData,
                                                                ItemDetails: prevSaveData.ItemDetails.map((item, i) => {
                                                                    if (i === bodyIndex) {
                                                                        return { ...item, Remarks: inputValue };
                                                                    }
                                                                    return item;
                                                                })
                                                            }));
                                                        }
                                                    }}
                                                /></td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div >

                ) : (<> </>)
            }
                {/* Loder start*/}

                {/* Loder End*/}
            </>

            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}

        </main>
    )
}
export default StockReconciliation
